import { create } from 'zustand'

type AssistStatus = 'idle' | 'improving' | 'done' | 'error'

interface CampaignAssistState {
  status: AssistStatus
  improvedSubject: string | null
  improvedBody: string | null
  changesSummary: string | null
  errorMessage: string | null
  setStatus: (status: AssistStatus) => void
  setImproved: (subject: string, body: string, summary: string) => void
  setError: (message: string) => void
  reset: () => void
}

const initialState = {
  status: 'idle' as AssistStatus,
  improvedSubject: null,
  improvedBody: null,
  changesSummary: null,
  errorMessage: null,
}

export const useCampaignAssistStore = create<CampaignAssistState>((set) => ({
  ...initialState,
  setStatus: (status) => set({ status }),
  setImproved: (improvedSubject, improvedBody, changesSummary) =>
    set({ improvedSubject, improvedBody, changesSummary, status: 'done' }),
  setError: (errorMessage) => set({ errorMessage, status: 'error' }),
  reset: () => set(initialState),
}))
